import script from "./ConciliacaoMovimentacoesTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./ConciliacaoMovimentacoesTabela.vue?vue&type=script&setup=true&lang=js"

import "./ConciliacaoMovimentacoesTabela.vue?vue&type=style&index=0&id=f96e8d4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f96e8d4c"]])

export default __exports__